export const lightTheme = {
  colorScheme: "light",
  globalStyles: (theme) => ({
    body: {
      ...theme.fn.fontStyles(),
      // backgroundColor: theme.colors.gray[0],
    },
  }),
};
